import React from "react";
import { createBrowserHistory } from "history";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import HomeRoute, {
  Catalogo,
  Residencial,
  Habitacional,
  Consorcio,
  CentralDocumentos,
  CapAluguel,
  Capitalizacao,
} from "../modules";
import { envs, links } from "../config";
import { GoogleAnalytics } from "../components/GoogleAnalytics/GoogleAnalytics";
import AccessibilityButton from "../components/common/AccessibilityButton";

export const history = createBrowserHistory();

const MainRouter = () => {
  return (
    <Router>
      <Switch>
        {envs.enableExampleRoute ? (
          <Route path="/catalogo" component={Catalogo} />
        ) : null}
        <Route path={links.capitalizacao.home} component={Capitalizacao} />
        <Route path={links.consorcio.home} component={Consorcio} />
        <Route path={links.capaluguel.home} component={CapAluguel} />
        <Route path={links.residencial.home} component={Residencial} />
        <Route path={links.habitacional.home} component={Habitacional} />
        <Route path="/documentos" component={CentralDocumentos} />
        <Redirect
          from={links.habitacional.emprestimos}
          to={links.habitacional.home}
        />
        <Route path="/" exact component={HomeRoute} />
      </Switch>
      <GoogleAnalytics />
      <AccessibilityButton />
    </Router>
  );
};

MainRouter.propTypes = {};

export default MainRouter;
